import React, { useEffect } from "react";
import { Link } from "react-router-dom";

//i18n
import SidebarContent from "./SidebarContent";


function Sidebar() {
	function tToggle() {
		// setVisibleSidebar(!visibleSidebar)
		// var body = document.body;	
		// body.classList.toggle("vertical-collpsed");
		// body.classList.toggle("sidebar-enable");
	}

	useEffect(() => {
	}, [])

	return (
		<div className="vertical-menu">
			<div className="navbar-brand-box">
				{/* BREND — korxonaning O'ZINIKI (helpers/brand.js).
				    Ilgari bu yerda ASProfil logotipi qattiq yozilgan edi va
				    HAMMA tenantga ko'rinardi.

				    ⚠️ Bu ustun 50px (verical.css:290 `width: 50px !important`),
				       ya'ni amalda faqat `logo-sm` ko'rinadi. Shuning uchun bu
				       yerda korxona NOMI matn bilan yozilmaydi — u sig'maydi;
				       nom keng panelda (SidebarContent, `.second-sidebar`)
				       ko'rsatiladi. Bu yerda faqat belgi: logotip -> favicon. */}
				{/* ⚠️ MAHSULOT LOGOTIPI (Tameer), korxonaniki EMAS.
				    Egasining qarori 2026-09-10: dastur sotila boshlagani uchun
				    yon menyuda Tameer turadi. Ilgari bu yerda tenantning o'z
				    logotipi chiqardi va `sifatmetall` kartochkasiga xato
				    yozilgan ASProfil logotipi butun ekranda ko'rinib turgan edi.
				    Korxona brendi CHEKDA va shikoyat plakatida qoladi. */}
				<Link to="/documents-in" className="logo logo-dark" tabIndex="-1">
					<span className="logo-sm">
						<img src="/favicon.svg" alt="Tameer"
							style={{ maxWidth: 30, maxHeight: 30 }} />
					</span>
					<span className="logo-lg">
						<img src="/tameer-logo.png" alt="Tameer"
							style={{ maxWidth: 130, maxHeight: 34 }} />
					</span>
				</Link>
			</div>
			<button tabIndex="-1" onClick={() => tToggle()}
				type="button" className="btn btn-sm px-3 header-item waves-effect vertical-menu-btn">
				<i className="uil-bars fz-20" />
			</button>
			<div data-simplebar className="h-100">
				<SidebarContent />
			</div>
		</div>
	);
};

export default Sidebar